@let department = this.department$() | async;
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    @if (department) {
      {{ department.name }}
    }
  </cam-error>
</cam-loader>
